/* lp-shop-range — <lp-shop-range>: grouped buy cards. Card behaviour (option pills, quantity, add to bag,
   cart events, GA4, order-value nudge) is inherited from LpProductDuo in lp-product-duo.js, loaded first.
   This file adds: group tabs (one panel visible, sliding thumb), option value labels (Value=Label map), lp:product-change → open the
   group holding that product (hero cards / range picker), and theme-editor block selection → open its group. */
(function () {
  'use strict';

  function define() {
    if (window.customElements.get('lp-shop-range') || !window.LpProductDuo) return false;

    class LpShopRange extends window.LpProductDuo {
      connectedCallback() {
        try { this.valueLabels = JSON.parse(this.dataset.valueLabels || '{}') || {}; } catch (e) { this.valueLabels = {}; }
        super.connectedCallback();
        var self = this;
        /* an empty first group would leave nothing selected: fall back to the first rendered panel */
        if (!this.querySelector('[data-lp-group-panel]:not([hidden])')) { var f = this.querySelector('[data-lp-group-panel]'); if (f) this.showGroup(f.dataset.lpGroupPanel); }
        if (window.LP) {
          this.offChange = window.LP.on('product-change', function (e) {
            var h = e.detail && e.detail.handle; if (!h || (e.detail.source || '').indexOf('lp-shop-range') === 0) return;
            self.reveal(h);
          });
        }
        /* sliding thumb behind the selected tab; repositioned on resize and after fonts settle */
        this.tabs = this.querySelector('[data-lp-group-tabs]');
        if (this.tabs) {
          this.thumb = document.createElement('span'); this.thumb.className = 'lp-shop-range__tab-thumb'; this.thumb.setAttribute('aria-hidden', 'true');
          this.tabs.appendChild(this.thumb); this.tabs.classList.add('has-thumb');
          this.moveThumb(true);
          if ('ResizeObserver' in window) { this.ro = new ResizeObserver(function () { self.moveThumb(true); }); this.ro.observe(this.tabs); }
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self.moveThumb(true); });
        }
        /* after a successful add from this section, the button reads "Added" for a moment */
        if (window.LP) {
          this.offAdd = window.LP.on('cart-add', function (e) {
            var d = e.detail || {}; if (d.source !== self.gaSource || !d.items || !d.items[0]) return;
            var id = String(d.items[0].id);
            self.cards.forEach(function (card) {
              var v = self.variant(card); if (!v || String(v.id) !== id) return;
              var btn = card.el.querySelector('[data-lp-atc]'), lbl = card.el.querySelector('[data-lp-atc-label]'); if (!btn || !lbl) return;
              var was = lbl.textContent; btn.classList.add('is-added'); lbl.textContent = lbl.dataset.added || 'Added';
              setTimeout(function () { btn.classList.remove('is-added'); if (lbl.textContent === (lbl.dataset.added || 'Added')) lbl.textContent = was; }, 1400);
            });
          });
        }
        /* theme editor: selecting a card or group block opens its tab */
        this.onBlockSelect = function (e) {
          var el = e.target && e.target.closest ? e.target.closest('[data-lp-group-of], [data-lp-group-tab]') : null;
          if (!el || !self.contains(el)) return;
          self.showGroup(el.dataset.lpGroupOf || el.dataset.lpGroupTab);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
      disconnectedCallback() {
        if (this.offChange) this.offChange();
        if (this.offAdd) this.offAdd();
        if (this.ro) this.ro.disconnect();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
      onClick(e) {
        var tab = e.target.closest('[data-lp-group-tab]');
        if (tab && this.contains(tab)) { e.preventDefault(); this.showGroup(tab.dataset.lpGroupTab); return; }
        super.onClick(e);
      }
      showGroup(id) {
        if (!id) return; id = String(id);
        var self = this;
        var next = this.querySelector('[data-lp-group-panel="' + id + '"]'); if (!next) return;
        var cur = this.querySelector('[data-lp-group-panel]:not([hidden])');
        Array.prototype.forEach.call(this.querySelectorAll('[data-lp-group-tab]'), function (t) { t.setAttribute('aria-selected', t.dataset.lpGroupTab === id); });
        this.moveThumb();
        if (cur === next) return;
        var swap = function () {
          Array.prototype.forEach.call(self.querySelectorAll('[data-lp-group-panel]'), function (p) { p.hidden = p !== next; p.classList.remove('is-leaving'); });
          next.classList.add('is-entering'); setTimeout(function () { next.classList.remove('is-entering'); }, 700);
        };
        var motion = window.LP ? window.LP.motionOK : !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (cur && motion) { cur.classList.add('is-leaving'); clearTimeout(this.swapTimer); this.swapTimer = setTimeout(swap, 160); }
        else swap();
      }
      /* place the thumb under the selected tab (instant = no transition, for layout changes) */
      moveThumb(instant) {
        if (!this.thumb || !this.tabs) return;
        var on = this.tabs.querySelector('[data-lp-group-tab][aria-selected="true"]'); if (!on) return;
        var th = this.thumb;
        if (instant) th.style.transition = 'none';
        th.style.width = on.offsetWidth + 'px';
        th.style.setProperty('--lp-shop-range-thumb-x', (on.offsetLeft - this.tabs.clientLeft) + 'px');
        if (instant) { void th.offsetWidth; th.style.transition = ''; }
        /* keep the selected tab in view when the tab row itself scrolls (many groups at 375px) */
        if (this.tabs.scrollWidth > this.tabs.clientWidth) on.scrollIntoView({ block: 'nearest', inline: 'center', behavior: instant ? 'auto' : 'smooth' });
      }
      /* open the group that holds this product; on a carousel, scroll that card into view */
      reveal(handle) {
        var card = this.querySelector('[data-lp-card][data-handle="' + handle + '"]'); if (!card) return;
        this.showGroup(card.dataset.lpGroupOf);
        var track = card.closest('[data-lp-group-track]');
        if (track && track.scrollWidth > track.clientWidth) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'auto' });
      }
      /* base render, then apply the marketer's Value=Label map to the pills and the selected-value readout,
         then the card's own Option=Label names and selected-value prefix (e.g. "Size: Age 4-5") */
      render(card) {
        var self = this;
        super.render(card);
        var map = this.valueLabels || {};
        if (Object.keys(map).length) {
          Array.prototype.forEach.call(card.el.querySelectorAll('[data-lp-option]'), function (b) {
            var v = b.dataset.lpValue; if (map[v] != null) b.textContent = map[v];
          });
          Array.prototype.forEach.call(card.el.querySelectorAll('.' + this.clsPrefix + '__label > span'), function (sp) {
            var v = sp.textContent; if (map[v] != null) sp.textContent = map[v];
          });
        }
        var names = {}; try { names = JSON.parse(card.el.dataset.lpOptionNames || '{}') || {}; } catch (e) { names = {}; }
        var prefix = (card.el.dataset.lpValuePrefix || '').trim();
        if (!Object.keys(names).length && !prefix) return;
        Array.prototype.forEach.call(card.el.querySelectorAll('.' + this.clsPrefix + '__group'), function (g) {
          var name = g.getAttribute('aria-label') || '', lbl = g.querySelector('.' + self.clsPrefix + '__label'), sp = lbl && lbl.querySelector('span');
          if (!lbl || !sp) return;
          if (names[name] != null) { g.setAttribute('aria-label', names[name]); lbl.firstChild.nodeValue = names[name]; }
          var n = name.toLowerCase();
          if (prefix && sp.textContent && n !== 'colour' && n !== 'color') sp.textContent = prefix + ' ' + sp.textContent;
        });
      }
    }

    window.customElements.define('lp-shop-range', LpShopRange);
    return true;
  }

  if (define()) return;
  /* both scripts are deferred and ordered, but guard against the base arriving later */
  var tries = 0, t = setInterval(function () { if (define() || ++tries > 50) clearInterval(t); }, 40);
})();
